module.exports = __webpack_public_path__ + "media/categories/1032-109130aa.svg";